import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-header-aff',
  templateUrl: './header-aff.component.html',
  styleUrls: ['./header-aff.component.scss']
})
export class HeaderAffComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
